import angular from 'angular';

(function() {
    'use strict';

    var kissOrderFilter = {
        templateUrl: require('./filter.html'),
        bindings: {
            criterias: '=', // Critères de recherches
            searchFunction: '&' // Fonction de recherche
        },
        controller: KissOrderFilterController
    };

    KissOrderFilterController.$inject = ['ORDERS', '$filter'];

    function KissOrderFilterController(ORDERS, $filter) {
        let vm = this;
        var defaultCriterias = vm.criterias;

        vm.status = ORDERS.status.defaultStatus;
        vm.translatedStatus = translatedStatus;

        this.clearForm = function() {
            clearCriterias();
            vm.searchFunction();
        };

        function clearCriterias() {
            angular.copy(defaultCriterias, vm.criterias);
        }

        /**
         * Utilisé pour le tri des status.
         */
        function translatedStatus(status) {
            return $filter('translate')('kiss_order.status.' + status);
        }
    }

    angular.module('app.kissorder').component('kissOrderFilter', kissOrderFilter);
})();
